export default {"src":"/_next/static/media/otpvarification.058a8493.svg","height":224,"width":264,"blurWidth":0,"blurHeight":0};